import { HttpError } from '@nzyme/fetch-utils/HttpError.js';
/**
 * Error thrown when an RPC call returns a non-OK response with structured error data.
 *
 * Extends {@link HttpError} so callers can narrow on a single error type regardless of whether the
 * failure carried structured data (`RpcError`) or not (`FetchError`); `status` is inherited from it.
 */
export class RpcError extends HttpError {
    /**
     * The response that caused the error
     */
    response;
    /**
     * The error data
     */
    data;
    /** Creates an RpcError from a failed HTTP response and its parsed error data. */
    constructor(response, data) {
        super(response.status, data.message);
        this.name = 'RpcError';
        this.data = data;
        this.response = response;
    }
}
//# sourceMappingURL=RpcError.js.map